import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Country, State, City } from "country-state-city";
import apiEndPoint from "../../services/apiService/apiEndPoints";
import { postApi } from "../../services/apiService/fetchMethod";
import tostMessage from "../../utils/tostMessage";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import * as Yup from "yup";
import { Formik, Form, ErrorMessage } from "formik";
import Select from "react-select";
import styles from "./styles/styles.module.css";
import { useLocation } from "react-router-dom";
import FormikInput from "../../commonComponents/InputField/FormikInput";
function ThirdStep({setStep}) {
  let { state } = useLocation();
  const [ dataForUser, setDataForUser ] = useState({
    roleId: null,
    clusterId: null,
    alertId: null,
    project_id:null
  });
  useEffect(() => {
    (async () => {
      const url = apiEndPoint().For_user_create;
      const { status, data } = await postApi({
        url,
        params: { code: localStorage.getItem("code") },
      });
      if (status === 200) {
        console.log(status, data);
        setDataForUser(data.data);
      }
    })();
  }, []);  
  const handleSubmit = async (val) => {
    let url = state
      ? apiEndPoint().UPDATE_WAREHOUSE
      : apiEndPoint().CREATE_WAREHOUSE2;

    const { status, data } = await postApi({
      url,
      params: {
        id: state?._id,
        name: val.name,
        country: val.country,
        state: val.stateVal,
        city: val.city,
        pincode: val.pincode,
        location: val.location,
        warehouseImg: val.warehouseImg,
        latitude: val.latitude,
        longitude: val.longitude,
        selected_project:dataForUser.project_id
      },
    });
    tostMessage(status, data.message);
    if (status === 200) {
      console.log(status, data);
      setStep(3)
    }
  };
  const handleImgUpload = (e, setFieldValue) => {
    const file = e.target.files[0];
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = function () {
      setFieldValue("warehouseImg", reader.result);
    };
  };
  const initialVal = {
    name: state ? state?.warehouse_name : "",
    country: state ? state?.warehouse_country : "",
    stateVal: state ? state?.warehouse_state : "",
    city: state ? state?.warehouse_city : "",
    pincode: state ? state?.warehouse_pincode : "",
    location: state ? state?.warehouse_location : "",
    warehouseImg: state?.warehouse_img ? state.warehouse_img : "",
    longitude: state ? state?.longitude : "",
    latitude: state ? state?.latitude : "",
  };

  const validationSchema = Yup.object().shape({
    name: Yup.string()
      .required("Name is required"),
    country: Yup.object().required("Please select an option"),
    stateVal: Yup.object().required("Please select an option"),
    city: Yup.object().required("Please select an option"),
    location: Yup.string().required("Location is required"),
    pincode: Yup.string()
      .matches(/^[1-9]{1}[0-9]{2}\s{0,1}[0-9]{3}$/, "Invalid Pincode")
      .required("Pincode is required"),
  });

  console.log(
    State?.getStatesOfCountry("IN").map((item) => ({
      name: item.name,
      city: City.getCitiesOfState("IN", item.isoCode),
    }))
  );

  return (
    <div className={styles.warehouseWrapper} style={{marginTop:"1rem"}}>
      
      <Formik
        initialValues={initialVal}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ touched, errors, setFieldValue, values, setFieldTouched }) => (
          <Form style={{ paddingInline: "5px" }}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <FormikInput
                  placeholder="Enter Sites Name"
                  labelVal="Sites Name"
                  name="name"
                  touched={touched.name}
                  errors={errors.name}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <div style={{ marginBottom: "0.4rem" }}>
                  <label style={{ fontWeight: "500" }}>Sites Image</label>
                </div>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <img
                    src={
                      !values.warehouseImg
                        ? "https://modernize-angular-main.netlify.app/assets/images/profile/user-1.jpg"
                        : values.warehouseImg
                    }
                    alt="selectedImg"
                    height={50}
                    width={50}
                    style={{ marginInline: "6px", borderRadius: "5px" }}
                  />
                  <label
                    htmlFor="warehouseImg"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      color: "blue",
                      fontWeight: "600",
                      fontSize: "12px",
                    }}
                  >
                    <CloudUploadIcon />
                    <span style={{ marginInline: "10px" }}>Upload Img</span>
                  </label>
                  <input
                    id="warehouseImg"
                    type="file"
                    accept="image/*"
                    onChange={(e) => {
                      handleImgUpload(e, setFieldValue);
                    }}
                    style={{ visibility: "hidden" }}
                  />
                </div>
              </Grid>
              <Grid item xs={12} sm={6}>
                <div style={{ marginBlock: "0.4rem" }}>
                  <label style={{ fontWeight: "500" }}>Country Name</label>
                </div>
                <Select
                  options={Country.getAllCountries()}
                  placeholder="Country Name"
                  getOptionLabel={(options) => {
                    return options["name"];
                  }}
                  getOptionValue={(options) => {
                    return options["name"];
                  }}
                  value={values.country}
                  onChange={(val) => {
                    setFieldValue("stateVal", null);
                    setFieldValue("city", null);
                    setFieldValue("country", {
                      name: val.name,
                      isoCode: val.isoCode,
                    });
                  }}
                  onBlur={() => {
                    setFieldTouched("country", true);
                  }}
                  theme={(theme) => ({
                    ...theme,
                    colors: {
                      ...theme.colors,
                      primary: "rgb(195, 193, 193)",
                    },
                  })}
                  styles={{
                    control: (baseStyles, state) => ({
                      ...baseStyles,
                      background: "rgb(243, 243, 243)",
                      padding: "0.35rem",
                      outline:
                        !values.country && touched.country
                          ? "1.5px solid red"
                          : state.isFocused && "1.5px solid rgb(195, 193, 193)",
                      border:
                        !values?.country && touched.country
                          ? "1.5px solid red"
                          : state.isFocused && "1.5px solid rgb(195, 193, 193)",
                    }),
                  }}
                />
                {!values?.country && (
                  <ErrorMessage
                    name="country"
                    component="div"
                    className="errorMsg"
                  />
                )}
              </Grid>
              <Grid item xs={12} sm={6}>
                <div style={{ marginBlock: "0.4rem" }}>
                  <label style={{ fontWeight: "500" }}>State Name</label>
                </div>
                <Select
                  options={State?.getStatesOfCountry(values.country.isoCode)}
                  placeholder="State Name"
                  getOptionLabel={(options) => {
                    return options["name"];
                  }}
                  getOptionValue={(options) => {
                    return options["name"];
                  }}
                  value={values.stateVal}
                  onChange={(val) => {
                    setFieldValue("city", null);
                    setFieldValue("stateVal", {
                      name: val.name,
                      isoCode: val.isoCode,
                    });
                  }}
                  onBlur={() => {
                    setFieldTouched("stateVal", true);
                  }}
                  theme={(theme) => ({
                    ...theme,
                    colors: {
                      ...theme.colors,
                      primary: "rgb(195, 193, 193)",
                    },
                  })}
                  styles={{
                    control: (baseStyles, state) => ({
                      ...baseStyles,
                      background: "rgb(243, 243, 243)",
                      padding: "0.35rem",
                      outline:
                        !values.stateVal && touched.stateVal
                          ? "1.5px solid red"
                          : state.isFocused && "1.5px solid rgb(195, 193, 193)",
                      border:
                        !values?.stateVal && touched.stateVal
                          ? "1.5px solid red"
                          : state.isFocused && "1.5px solid rgb(195, 193, 193)",
                    }),
                  }}
                />
                {!values?.stateVal && touched.stateVal && (
                  <ErrorMessage
                    name="stateVal"
                    component="div"
                    className="errorMsg"
                  />
                )}
              </Grid>
              <Grid item xs={12} sm={6}>
                <div style={{ marginBlock: "0.4rem" }}>
                  <label style={{ fontWeight: "500" }}>City Name</label>
                </div>
                <Select
                  options={City.getCitiesOfState(
                    values?.country?.isoCode,
                    values?.stateVal?.isoCode
                  )}
                  placeholder="City Name"
                  getOptionLabel={(options) => {
                    return options["name"];
                  }}
                  getOptionValue={(options) => {
                    return options["name"];
                  }}
                  value={values.city}
                  onChange={(val) => {
                    setFieldValue("city", {
                      name: val.name,
                      latitude: val.latitude,
                      longitude: val.longitude,
                    });
                  }}
                  onBlur={() => {
                    setFieldTouched("city", true);
                  }}
                  theme={(theme) => ({
                    ...theme,
                    colors: {
                      ...theme.colors,
                      primary: "rgb(195, 193, 193)",
                    },
                  })}
                  styles={{
                    control: (baseStyles, state) => ({
                      ...baseStyles,
                      background: "rgb(243, 243, 243)",
                      padding: "0.35rem",
                      outline:
                        !values.city && touched.city
                          ? "1.5px solid red"
                          : state.isFocused && "1.5px solid rgb(195, 193, 193)",
                      border:
                        !values?.city && touched.city
                          ? "1.5px solid red"
                          : state.isFocused && "1.5px solid rgb(195, 193, 193)",
                    }),
                  }}
                />
                {!values?.city && touched.city && (
                  <ErrorMessage
                    name="city"
                    component="div"
                    className="errorMsg"
                  />
                )}
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormikInput
                  placeholder="Enter Pincode"
                  labelVal="Pincode"
                  name="pincode"
                  touched={touched.pincode}
                  errors={errors.pincode}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <FormikInput
                  placeholder="Enter Latitude"
                  labelVal="Latitude"
                  name="latitude"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormikInput
                  placeholder="Enter Longitude"
                  labelVal="Longitude"
                  name="longitude"
                />
              </Grid>
              <Grid item xs={6}>
                <FormikInput
                  placeholder="Enter Location"
                  labelVal="Location"
                  name="location"
                  touched={touched.location}
                  errors={errors.location}
                />
              </Grid>
              

              <Grid item xs={12}>
                <div className="addRole">
                  <button type="submit" className="buttonAddRole">
                    {state ? <span>Update Sites </span> : <>Submit</>}
                  </button>
                </div>
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>
    </div>
  );
}


export default ThirdStep